import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class VenuesView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    // mapContainer
    const mapContainer = container.querySelector(".venues-main .m-map")
    if (mapContainer) {
      TweenMax.set(mapContainer, {opacity: 1})
      TweenMax.from(mapContainer, .4, {opacity: 0, delay: .1})
    }
    const listWrapper = container.querySelector(".venues-main .list-wrapper")
    if (listWrapper) {
      TweenMax.set(listWrapper, {opacity: 1})
      TweenMax.from(listWrapper, .4, {opacity: 0, delay: .15})
    }
    const items = [...container.querySelectorAll(".venues-main .venue-mapdata .venue-inner")]
    TweenMax.set(items, {y: 0, opacity: 1})
    TweenMax.from(items, .1, {opacity: 0, delay: (i) => .35 + i * .07, ease: Power3.easeOut})
    TweenMax.from(items, .4, {y: 100, delay: (i) => .35 + i * .07, ease: Power3.easeOut})
    
    
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    
    const items = [...container.querySelectorAll(".venues-main .venue-mapdata .venue-inner")]
    TweenMax.to(items, .4, {y: 100, opacity: 0, delay: (i) => i * .07, ease: Power3.easeIn})
    const listWrapper = container.querySelector(".venues-main .list-wrapper")
    if (listWrapper) {
      TweenMax.to(listWrapper, .4, {opacity: 0, delay: .15})
    }
    // mapContainer
    const mapContainer = container.querySelector(".venues-main .m-map")
    if (mapContainer) {
      TweenMax.to(mapContainer, .4, {opacity: 0, delay: .2})
    }
  }

}

export default VenuesView